import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateIngredientSimpleDetails(
    $id: ID!
    $data: IngredientSimpleDetailsInput!
  ) {
    updateIngredientSimpleDetails(id: $id, data: $data) {
      id
      position
      updatedAt

      updatedBy {
        id
        name
      }

      description
      isExcludedFromSearch
    }
  }
`

export default UPDATE_INGREDIENT_SIMPLE_DETAILS_MUTATION
